import { InjectionToken } from '@angular/core';

import { CardsApi } from './cards-api.interface';

export const CARDS_API = new InjectionToken<CardsApi>('CARDS_API');
